export { default } from './colourMap'
